import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import { STORAGE_KEYS } from '../Util/key_helper';

// Function to extract the main domain from a URL
export function extractMainDomain(url) {
    if (!url) return "";

    // Remove protocol (http, https, etc.)
    let ret_name = url.replace(/(^\w+:|^)\/\//, '');
    // Remove www. if present
    if (ret_name.startsWith('www.')) {
        ret_name = ret_name.substring(4);
    }
    // Remove path and query params
    ret_name = ret_name.split('/')[0].split('?')[0];
    return ret_name;
}

export function getDomainName(need_flat = false) {
    const base_url = window.location.origin;
    if (need_flat) {
        return extractMainDomain(base_url).replaceAll(".", "_");
    }
    if (base_url.includes("localhost") || base_url.includes("192.168") || base_url.includes("127.0.0.1")) {
        // return "https://algodelta.com";
        return "https://new1.investmentvidhya.com";

    }
    return base_url;
}

export const formatStanderdTimeString = (inputTime) => {
    const inputDate = new Date(inputTime);

    // Check if inputDate is a valid date
    if (!isNaN(inputDate.getTime())) {
        const year = inputDate.getFullYear();
        const month = (inputDate.getMonth() + 1).toString().padStart(2, "0");
        const day = inputDate.getDate().toString().padStart(2, "0");
        const hours = inputDate.getHours().toString().padStart(2, "0");
        const minutes = inputDate.getMinutes().toString().padStart(2, "0");
        const seconds = inputDate.getSeconds().toString().padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
        // If inputTime is not a valid date, return it as is (assumed to be in "hh:mm:ss" format)
        return inputTime;
    }
};

// Function For Get Current Date 
export const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0"); // Months are zero-based
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
};
//Function to gt Current Date and time For export file name
export function getYMDHMSFormat() {
    const date = new Date();
    // Convert to Indian Standard Time (IST)
    const istDate = new Date(date.toLocaleString("en-US", { timeZone: "Asia/Kolkata" }));
    // Format date as "yyyyMMdd"
    const year = istDate.getFullYear();
    const month = (istDate.getMonth() + 1).toString().padStart(2, "0");
    const day = istDate.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}${month}${day}`;
    // Format time as "hhmmss" in 24-hour format
    const hours = istDate.getHours().toString().padStart(2, "0");
    const minutes = istDate.getMinutes().toString().padStart(2, "0");
    const seconds = istDate.getSeconds().toString().padStart(2, "0");
    const formattedTime = `${hours}${minutes}${seconds}`;
    // Combine date and time with an underscore separator
    return `${formattedDate}_${formattedTime}`;
}
export const handleSearchSortData = (data, searchValue, searchFields, selectedSortOption, sortOrder) => {
    if (!data) return [];

    let filteredData = [...data];

    // --- Search ---
    if (searchValue) {
        const lowercasedSearch = searchValue.toLowerCase();
        filteredData = filteredData.filter((item) =>
            searchFields?.some((field) =>
                item[field]?.toLowerCase().includes(lowercasedSearch)
            )
        );
    }

    // --- Sort ---
    if (selectedSortOption) {
        const field = selectedSortOption.value;

        filteredData.sort((a, b) => {
            // Custom logic to extract values from nested structure
            const getValue = (obj) => {
                if (field in obj) return obj[field];
                if (obj.account_info && field in obj.account_info) return obj.account_info[field];
                return undefined;
            };

            const valueA = getValue(a);
            const valueB = getValue(b);

            // Handle strings vs numbers
            if (typeof valueA === "string" && typeof valueB === "string") {
                return sortOrder === "ascending"
                    ? valueA.localeCompare(valueB)
                    : valueB.localeCompare(valueA);
            } else {
                return sortOrder === "ascending"
                    ? (valueA ?? 0) - (valueB ?? 0)
                    : (valueB ?? 0) - (valueA ?? 0);
            }
        });
    }

    return filteredData;
};

//Copy To clipboard function
export const copyToClipboard = (text) => {
    if (navigator.clipboard && navigator.clipboard.writeText) {
        // Use the modern Clipboard API if available
        navigator.clipboard
            .writeText(text)
            .then(() => {
                toast.success("Copied successfully!", {
                    hideAfter: 3,
                });
            })
            .catch((err) => {
                console.log("Failed to copy text with Clipboard API:", err);
            });
    } else {
        // Fallback for older browsers
        try {
            const textarea = document.createElement("textarea");
            textarea.value = text;
            textarea.style.position = "fixed"; // Avoid scrolling to the bottom
            document.body.appendChild(textarea);
            textarea.select();
            document.execCommand("copy");
            document.body.removeChild(textarea);

            toast.success("Text Copied", {
                hideAfter: 3,
            });
        } catch (err) {
            console.error("Fallback: Unable to copy text", err);
        }
    }
};
// Function for get Ip Processing Status
export function getIpProcessingStatus(createTime, currentTime = Date.now()) {
    const createdAt = new Date(createTime).getTime();

    // Prevent negative seconds (in case createTime is in the future)
    const secondsSinceCreated = Math.max(0, Math.floor((currentTime - createdAt) / 1000));

    const isProcessing = secondsSinceCreated < 60;
    const progressPercent = Math.min(100, (secondsSinceCreated / 60) * 100);
    const secondsRemaining = Math.max(0, 60 - secondsSinceCreated);

    return {
        isProcessing,
        progressPercent: Math.floor(progressPercent),
        secondsRemaining
    };
}
// Function to get quantity label based on script type
export const getQuantityLabel = (scriptType) => {
    const quantityTypes = ["NSE", "BSE", "EQUITY", "EQ"];
    // Ensure scriptType is always treated as a string
    const typeValue = typeof scriptType === "object" ? scriptType?.value : scriptType;
    // Default to "Quantity" if scriptType is null, undefined, or an empty string
    if (!typeValue) {
        return { label: "Quantity", placeholder: "Enter Quantity" };
    }

    return quantityTypes.includes(typeValue.toUpperCase())  // Ensure case insensitivity
        ? { label: "Quantity", placeholder: "Enter Quantity" }
        : { label: "Order Lot", placeholder: "Enter Order Lot" };
};

// Utility function for format expiry date of account
export function fromatExpiryDate(dateString) {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";

    const options = { day: 'numeric', month: 'short', year: 'numeric' };

    return new Intl.DateTimeFormat('en-GB', options).format(date);
}
// Function to check that is Boker panel user or not 
export const checkBrokerPanelUser = () => {
    const token = localStorage.getItem(STORAGE_KEYS.BROKER_PANEL_USER_ACCESS_TOKEN);
    if (!token) return false;
    try {
        const decoded = jwtDecode(token);
        return decoded.is_brokerpanel === true;

    } catch (error) {
        console.log("Invalid token:", error);
        return false;
    }
};

export function isAlgoDeltaDomain(domain) {
    if (!domain) return false;

    const normalized = domain
        .replace(/(^\w+:|^)\/\//, '')     // remove protocol
        .replace(/^www\./, '')            // remove 'www.'
        .split('/')[0]                    // remove path
        .split('?')[0]                    // remove query
        .toLowerCase();

    return normalized.includes("algodelta");
}
// functuin for get position moddal action title showcase based on flag 
export const getPositionModalActionLabel = ({ is_tgt, is_sl, is_start_time, is_end_time, is_entry, is_trail, is_rollover }) => {
    if (is_tgt) return "Target";
    if (is_sl) return "StopLoss";
    if (is_start_time) return "Start Time";
    if (is_end_time) return "End Time";
    if (is_entry) return "Entry";
    if (is_trail) return "Trailing";
    if (is_rollover) return "Rollover";
    return "Trailing";
};

export function logoutUser(navigate) {
    localStorage.removeItem(STORAGE_KEYS.BROKER_PANEL_USER_ACCESS_TOKEN);
    localStorage.removeItem(STORAGE_KEYS.BROKER_PANEL_USER_REMEMBER_ME);
    localStorage.removeItem(STORAGE_KEYS.USER_PERMISSION);
    localStorage.setItem(STORAGE_KEYS.BROKER_PANEL_USER_IS_LOGGIN_IN, "false");

    if (navigate) {
        navigate('/login'); // SPA navigation
    } else {
        window.location.href = "/user/login"; // Fallback for non-React code
    }
}

// function for generate payment link 
export function generatePaymentLink(payment_url, amount, sub_user_id, payment_type) {

    // Ensure payment_url ends with payment.php
    if (payment_url?.endsWith('/')) {
        payment_url += 'payment/payment.php';
    } else {
        payment_url += '/payment/payment.php';
    }

    const params = new URLSearchParams({ sub_user_id, amount, payment_type });
    return `${payment_url}?${params.toString()}`;
}

export const formatStrategyData = (strategies = []) => {
    return strategies.map(strategy => {
        const capital = parseFloat(strategy.capital_required) || 0;
        let cumulative = 0;
        let peak = capital;
        let maxDD = 0;
        const records = (strategy.position_pnl_records || []).map(r => {
            cumulative += r.pnl;
            const equity = capital + cumulative;
            if (equity > peak) peak = equity;
            const dd = ((equity - peak) / peak) * 100;
            if (Math.abs(dd) > maxDD) maxDD = Math.abs(dd);
            return {
                ...r,
                cumulative_pnl: cumulative,
                drawdown: parseFloat(dd.toFixed(2))
            };
        });

        const returnPercent = capital ? (cumulative / capital) * 100 : 0;

        return {
            ...strategy,
            position_pnl_records: records,
            totalPnL: cumulative,
            returnPercent: parseFloat(returnPercent.toFixed(2)),
            maxDD: parseFloat(maxDD.toFixed(2))
        };
    });
};

export const formatPositionHistoryChartData = (positions = [], capital = 0) => {
    if (!positions.length) return [];

    //roup PnL by date
    const grouped = positions.reduce((acc, pos) => {
        const date = pos.entry_time.split("T")[0]; // get YYYY-MM-DD
        const pnl = parseFloat(pos.pnl) || 0;

        if (!acc[date]) acc[date] = 0;
        acc[date] += pnl;

        return acc;
    }, {});
    //  Convert to sorted array
    const dailyRecords = Object.entries(grouped)
        .map(([date, pnl]) => ({
            record_date: date,
            pnl
        }))
        .sort((a, b) => new Date(a.record_date) - new Date(b.record_date));

    let cumulative = 0;
    let peak = capital;
    let maxDD = 0;

    //  Calculate cumulative pnl & drawdown
    const records = dailyRecords.map(r => {
        cumulative += r.pnl;
        const equity = capital + cumulative;
        if (equity > peak) peak = equity;
        const dd = ((equity - peak) / peak) * 100;
        if (Math.abs(dd) > maxDD) {
            maxDD = Math.abs(dd);
        }
        return {
            record_date: r.record_date,
            pnl: r.pnl,
            cumulative_pnl: parseFloat(cumulative.toFixed(2)),
            drawdown: parseFloat(dd.toFixed(2))
        };
    });

    return {
        records,
        totalPnL: parseFloat(cumulative.toFixed(2)),
        returnPercent: capital ? parseFloat(((cumulative / capital) * 100).toFixed(2)) : 0,
        maxDD: parseFloat(maxDD.toFixed(2))
    };
};
//Function for handle trim value or object all the filed trim value
export const trimValue = (value) => {
    if (typeof value === 'string') {
        return value.trim();
    }
    if (typeof value === 'object') {
        return Object.keys(value).reduce((acc, key) => {
            acc[key] = trimValue(value[key]);
            return acc;
        }, {});
    }
    return value;
};
export const getBridgeTriggerDraftKey = (bridge_id) => `${STORAGE_KEYS.BRIDGE_TRIGGER_LAST_ADDED}_${bridge_id}`;

export const normalizedBrokerName = (brokerName) => brokerName?.replace(/_no_ip|new$|auto$/i, "");

export function generateTimestampIp(excludeList = ['68.183.244.43']) {
    const generate = () => {
        const ts = Date.now();
        const str = ts.toString();
        const last8 = str.slice(-8);
        const octets = [];

        for (let i = 0; i < 8; i += 2) {
            const pair = parseInt(last8.substr(i, 2), 10);
            let octet = pair % 256;

            if (i === 0) {
                octet = (octet % 254) + 1; // Always 1-254
            }

            octets.push(octet);
        }

        return octets.join('.');
    };

    let ip = generate();
    let attempts = 0;

    while (excludeList.includes(ip) && attempts < 10) {
        ip = generate();
        attempts++;
    }

    return ip;
}